import { DifficultyChip } from '@exam-management/components';
import { Link } from '@exam-management/router';
import {
  Button,
  Chip,
  EllipsisText,
  EditOutlinedIcon,
  Text,
  type GridColDef,
} from '@shared/components';

import type { QuestionCreationDetailsRow } from '../../types';

export function getColumns({ hideMoreAction }: { hideMoreAction?: boolean } = {}) {
  const columns: GridColDef<QuestionCreationDetailsRow>[] = [
    {
      field: 'order',
      headerName: 'No',
      width: 60,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => <Text variant='body1'>{params.row.order}</Text>,
    },
    {
      field: 'chapter',
      headerName: 'Chapter',
      flex: 1,
      sortable: false,
      renderCell: (params) => <EllipsisText variant='body1'>{params.row.chapterName}</EllipsisText>,
    },
    {
      field: 'topic',
      headerName: 'Topic',
      flex: 1,
      sortable: false,
      renderCell: (params) => <EllipsisText variant='body1'>{params.row.topicName}</EllipsisText>,
    },
    {
      field: 'subTopic',
      headerName: 'Subtopic',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <EllipsisText variant='body1'>{params.row.subTopicName}</EllipsisText>
      ),
    },
    {
      field: 'calculation',
      headerName: 'Type',
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return params.row.calculation ? (
          <Chip
            label={<Text variant='captionSemibold'>{params.row.calculation}</Text>}
            size='small'
            sx={{
              backgroundColor: (theme) => theme.palette.grey[200],
              minWidth: '62px',
            }}
          />
        ) : (
          '-'
        );
      },
    },

    {
      field: 'difficulty',
      headerName: 'Difficulty',
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return params.row.difficulty ? <DifficultyChip type={params.row.difficulty} /> : '-';
      },
    },
    {
      field: 'moreAction',
      headerName: ' ',
      sortable: false,
      width: 88,
      align: 'center',
      renderCell: (params) => {
        if (hideMoreAction) {
          return null;
        }

        return (
          <Button
            sx={(theme) => ({ padding: theme.spacing(1, 3), minWidth: '76px' })}
            startIcon={<EditOutlinedIcon />}
            color='secondary'
            variant='outlined'
            size='small'
            component={Link}
            to={params.row.questionUrl.path}
            params={{ ...params.row.questionUrl.params }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            Edit
          </Button>
        );
      },
    },
  ];
  return columns;
}
